import MultiMarketLayout from '../components/markets_layout/multi_market_layout';
import SingleMarketLayout from '../components/markets_layout/single_market_layout';

const getMarketLayoutComponent = ({ layout }) => ({
  'multi-market': MultiMarketLayout,
}[layout] || SingleMarketLayout);

export default getMarketLayoutComponent;
